module.exports = __webpack_public_path__ + "static/media/moes-logo.f153e647.svg";